exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.obj-resources-table:last-child {\n    margin-bottom: 0;\n}\n\n/* make table heading hidden */\n@media (max-width: 500px) {\n.bg-secondary {\n        display: none !important;\n}\n}\ninput[type=checkbox]+label, input[type=radio]+label {\n    display: none !important;\n}\n.mobile-header-btn.left-corner,\n.mobile-header-btn.right-corner {\n    display: none;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dd90a932","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/ireaderResourcePage/ireaderResourcePage.vue
// module id = SQh7
// module chunks = 2 3 4 5 6